const filterOutEmojis = (str: string) =>
  str.split('').filter((_, index) => str.charCodeAt(index) <= 127)
    .join('')
    .replace(/\'+/g, '');

export default filterOutEmojis;
